<script generics="T extends string" lang="ts">
	import { RadioGroup } from 'bits-ui'

	export let value: T
	export let options: { value: T; label: string }[]
	export let ariaLabel: string
	export let name: string
	export let disabled: boolean
</script>

<RadioGroup.Root
	class="bg-background flex w-fit items-center justify-center gap-1 rounded-md border p-1 transition-colors"
	aria-label={ariaLabel}
	{disabled}
	orientation="horizontal"
	bind:value
>
	{#each options as { value, label } (value)}
		<RadioGroup.Item
			id={label}
			class="data-[state=checked]:bg-accent xs:px-2 block cursor-pointer rounded-sm px-1.5 text-sm focus-visible:ring-3 disabled:cursor-not-allowed disabled:opacity-50"
			{value}
		>
			{label}
		</RadioGroup.Item>
	{/each}

	<RadioGroup.Input {name} autocomplete="off" />
</RadioGroup.Root>
